module.exports = __webpack_public_path__ + "img/sw-s14.0fdfc132.svg";